/* ==========================================================================
   Elevate Floors — mecânica compartilhada de trilho infinito

   Usada pela Seção 05 (galeria, movimento contínuo) e pela Seção 08 (reviews,
   passo por cartão). O que é idêntico nas duas mora aqui: o loop infinito, o
   arraste e a inércia. O que difere — como o trilho avança sozinho — fica em
   cada seção.

   O loop: a lista é renderizada 3x e o scroll fica sempre no conjunto do meio.
   Quando escapa para as bordas, soma ou subtrai um conjunto inteiro. Como o
   conteúdo é idêntico, o salto é invisível.

   Se o salto cair no meio de um arraste, a referência do arraste precisa da
   mesma correção — senão o cartão pula sob o dedo.
   ========================================================================== */
(function () {
  'use strict';

  function attach(rail) {
    var state = { drag: null, momentum: null, hover: false, centered: false, tocando: false, soltou: null };

    /* rail.scrollWidth força o navegador a recalcular o layout na hora. Isso
       era pago a CADA pointermove e a cada evento de scroll — dezenas de vezes
       por segundo, sobre uma lista renderizada 3x com imagens e vídeos. Era a
       maior fonte de engasgo no arraste.

       Durante um arraste o conteúdo não muda de tamanho, então a medida é
       tirada uma vez no pointerdown e reusada até soltar. Fora do arraste
       segue medindo na hora, que é quando de fato pode ter mudado. */
    function larguraDoConjunto() {
      if (state.drag && state.drag.setW) return state.drag.setW;
      return rail.scrollWidth / 3;
    }

    function loop() {
      var setW = larguraDoConjunto();
      if (setW < 10) return 0;
      var shift = 0;
      if (rail.scrollLeft < setW * 0.5) shift = setW;
      else if (rail.scrollLeft > setW * 1.5) shift = -setW;
      if (shift) {
        rail.scrollLeft += shift;
        if (state.drag) state.drag.sl += shift;
      }
      return shift;
    }

    function center(offset) {
      if (state.centered || rail.scrollWidth < 10) return false;
      state.centered = true;
      rail.scrollLeft = rail.scrollWidth / 3 + (offset || 0);
      return true;
    }

    rail.addEventListener('pointerdown', function (e) {
      /* No TOQUE o arraste é do navegador, não nosso.

         O trilho já é overflow-x:auto com touch-action:pan-x, então o dedo o
         rola nativamente — com a inércia e o atrito do próprio sistema, que
         nenhuma imitação em JS alcança. Só que o código abaixo também movia o
         scrollLeft no mesmo gesto: dois motores empurrando o mesmo trilho, e o
         resultado era o arraste truncado.

         Deixando o toque para o navegador, sobra para o JS só o mouse, que não
         tem arraste nativo em container com overflow. O loop infinito continua
         valendo nos dois casos, porque ele é disparado pelo evento de scroll. */
      if (e.pointerType !== 'mouse') {
        /* Com o arraste por toque entregue ao navegador, state.drag fica nulo
           e o trilho passaria por "parado" justamente enquanto o dedo o
           empurra — o avanço automático somaria ao gesto. Esta marca é o que
           informa isIdle() de que existe uma interação em curso. */
        state.tocando = true;
        if (state.soltou) { clearTimeout(state.soltou); state.soltou = null; }
        return;
      }
      if (state.momentum) { cancelAnimationFrame(state.momentum); state.momentum = null; }
      state.drag = {
        x: e.clientX, sl: rail.scrollLeft,
        lastX: e.clientX, lastT: performance.now(), v: 0,
        alvoX: e.clientX, raf: null,
        // medido uma vez, para o loop() não recalcular layout a cada movimento
        setW: rail.scrollWidth / 3
      };
      rail.classList.add('is-grabbing');
      // captura: o arraste não morre se o cursor sair do trilho
      if (rail.setPointerCapture) { try { rail.setPointerCapture(e.pointerId); } catch (err) {} }
    });

    /* Escrever scrollLeft dentro do próprio pointermove desperdiça trabalho:
       um mouse de 120Hz dispara mais eventos do que existem quadros, e todas
       as escritas menos a última são jogadas fora. Guardar o alvo e aplicar
       uma vez por requestAnimationFrame dá exatamente o mesmo movimento com
       uma fração das escritas, e no instante em que o navegador vai pintar. */
    function aplicaArraste() {
      if (!state.drag) return;
      state.drag.raf = null;
      rail.scrollLeft = state.drag.sl - (state.drag.alvoX - state.drag.x);
      loop();
    }

    rail.addEventListener('pointermove', function (e) {
      if (!state.drag) return;
      var now = performance.now();
      var dt = now - state.drag.lastT;
      if (dt > 4) {
        var inst = (e.clientX - state.drag.lastX) / dt;
        // média móvel: um tranco no último milissegundo não define o lançamento
        state.drag.v = state.drag.v * 0.7 + inst * 0.3;
        state.drag.lastX = e.clientX;
        state.drag.lastT = now;
      }
      state.drag.alvoX = e.clientX;
      if (!state.drag.raf) state.drag.raf = requestAnimationFrame(aplicaArraste);
    });

    function release() {
      rail.classList.remove('is-grabbing');
      if (!state.drag) return;
      // um quadro pendente escreveria a posição antiga depois de soltar
      if (state.drag.raf) cancelAnimationFrame(state.drag.raf);
      var v = state.drag.v * 16;
      state.drag = null;
      if (Math.abs(v) < 0.1) return;
      var glide = function () {
        rail.scrollLeft -= v;
        v *= 0.94;               // atrito
        loop();
        state.momentum = Math.abs(v) > 0.1 ? requestAnimationFrame(glide) : null;
      };
      state.momentum = requestAnimationFrame(glide);
    }
    rail.addEventListener('pointerup', release);
    rail.addEventListener('pointercancel', release);

    /* Pausar no hover vale só onde EXISTE cursor. Com mouseenter/mouseleave o
       trilho parava para sempre no celular: o toque dispara um mouseenter
       sintético e o mouseleave correspondente muitas vezes nunca chega, então
       state.hover ficava travado em true e o movimento automático morria
       depois do primeiro toque — sem nenhum jeito de voltar a andar.

       pointerenter/pointerleave trazem o pointerType, então dá para ignorar
       touch e caneta e reagir só ao mouse de verdade. */
    rail.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'mouse') state.hover = true;
    });
    rail.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'mouse') state.hover = false;
    });
    /* rede de segurança: se por qualquer caminho o hover ficar preso em um
       dispositivo sem cursor, o fim de um toque o libera */
    /* Ao soltar, a rolagem nativa ainda desliza por um tempo. Retomar o avanço
       automático no mesmo instante somaria os dois movimentos, então a espera
       cobre essa inércia. */
    function fimDoToque(e) {
      if (e.pointerType === 'mouse') return;
      state.hover = false;
      if (state.soltou) clearTimeout(state.soltou);
      state.soltou = setTimeout(function () {
        state.tocando = false;
        state.soltou = null;
      }, 700);
    }
    rail.addEventListener('pointerup', fimDoToque);
    rail.addEventListener('pointercancel', fimDoToque);
    rail.addEventListener('scroll', loop, { passive: true });

    return {
      loop: loop,
      center: center,
      // true quando o trilho pode andar sozinho: centralizado e sem interação
      isIdle: function () {
        return state.centered && !state.drag && !state.hover && !state.momentum && !state.tocando;
      },
      isCentered: function () { return state.centered; }
    };
  }

  window.EFRail = { attach: attach };
})();
